export class StaffLoginDto {
    username: string;
    password: string;

    constructor() {
        this.username = '';
        this.password = '';
    }
}
